.ux-iws-navigation-locale-selection {
    display: none;

    &--open {
        display: block;
        position: absolute;
        width: 100%;
        top: 0;
        right: 0;
        left: 0;
        z-index: 20;
    }

    &__wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: $color-white;
        overflow-y: auto;
        height: 100vh;

        @media only screen and (min-width: $desktop-s-navigation-100) {
            min-height: 260px;
            height: 610px;
        }
    }

    &__headline-container {
        width: 80%;
        text-align: center;
        margin-bottom: 35px;

        @media only screen and (min-width: 768px) {
            margin-bottom: 45px;
        }

        @media only screen and (min-width: 1440px) {
            margin-bottom: 50px;
        }

        > *[slot="headline"] {
            line-height: $line-height-small;
        }
    }

    select {
        text-transform: capitalize;
    }

    &__selection-container {
        display: flex;
        flex-direction: column;
        width: 80%;
        margin: 0 auto;

        @media only screen and (min-width: 768px) {
            flex-direction: row;
            width: 485px;
        }
    }

    &__select-container .ux-select__wrapper {
        display: block;
        width: 100%;
        margin-bottom: 20px;
    }

    &__select-container {
        height: 66px;

        @media only screen and (min-width: 768px) {
            flex: 1 0 auto;
            margin-right: 20px;
        }
    }

    &__button-container {
        min-height: 44px;
    }

    &__button-container ux-button {
        display: block;
        width: 100%;
    }

    &__close-button {
        @include font(bold);
        position: absolute;
        top: 25px;
        right: 30px;
        height: 50px;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0;
        border: 0;
        background: none;
        outline: none;
        box-shadow: none;
        text-shadow: none;
        font-size: $size-text-smaller;
        color: $color-grey-3;
        text-transform: uppercase;
        line-height: normal;
        transition: color 0.2s ease-in-out;

        ux-icon {
            margin-left: 10px;
            color: $color-grey-3;
            transition: fill 0.2s ease-in-out;
            font-size: 16px;
        }

        @media only screen and (min-width: $desktop-s-navigation-100) {
            top: 42px;
        }

        &:focus-visible {
            outline: solid 1px black;
            outline-offset: 5px;
        }
    }

    @media only screen and (min-width: $desktop-s-navigation-100) {
        ux-icon {
            font-size: 20px;
        }
    }

    &__close-button:hover {
        color: $color-green;

        ux-icon {
            color: $color-green;
        }
    }
}

.ux-iws-nav-active--locale-selection:not(.ux-iws-nav-active) {
    .ux-iws-navigation-locale-selection {
        @media only screen and (min-width: $desktop-s-navigation-100) {
            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
        }
    }
}
